import type ITitleWrapper from './interfaces/ITitleWrapper';

import styles from './scss/TitleWrapper.module.scss';

function TitleWrapper({ title, description }: Readonly<ITitleWrapper>) {
  return (
    <div className={styles.titleWrapper}>
      {title ? (
        <span className={styles.title}>
          {title}
        </span>
      ) : null}
      {description ? (
        <span className={styles.description}>
          {description}
        </span>
      ) : null}
    </div>
  );
}

export default TitleWrapper;
